import { ToolType } from './drawing';
import { IconProps } from '../components/Icons';

export interface Tool {
  id: ToolType;
  name: string;
  icon: React.ComponentType<IconProps>;
  shortcut: string;
  isActive: boolean;
  config: ToolConfiguration;
}

export interface ToolConfiguration {
  strokeWidth: number;
  strokeColor: string;
  fillColor: string;
  fillOpacity: number;
  showFill: boolean;
  showStroke: boolean;
}

export interface ToolState {
  activeTool: ToolType;
  tools: Tool[];
  toolConfig: ToolConfiguration;
}

export const DEFAULT_TOOL_CONFIG: ToolConfiguration = {
  strokeWidth: 3,
  strokeColor: '#000000',
  fillColor: '#ffffff',
  fillOpacity: 1,
  showFill: false,
  showStroke: true,
};

import { 
  HandIcon,
  SelectIcon,
  PencilIcon, 
  LineIcon, 
  ArrowIcon, 
  RectangleIcon, 
  CircleIcon, 
  TextIcon, 
  EraserIcon 
} from '../components/Icons';

export const AVAILABLE_TOOLS: Omit<Tool, 'isActive' | 'config'>[] = [
  {
    id: 'hand',
    name: 'Hand',
    icon: HandIcon,
    shortcut: 'Space',
  },
  {
    id: 'select',
    name: 'Select',
    icon: SelectIcon,
    shortcut: '1',
  },
  {
    id: 'pencil',
    name: 'Pencil',
    icon: PencilIcon,
    shortcut: '2',
  },
  {
    id: 'line',
    name: 'Line',
    icon: LineIcon,
    shortcut: '3',
  },
  {
    id: 'arrow',
    name: 'Arrow',
    icon: ArrowIcon,
    shortcut: '4',
  },
  {
    id: 'rectangle',
    name: 'Rectangle',
    icon: RectangleIcon,
    shortcut: '5',
  },
  {
    id: 'circle',
    name: 'Circle',
    icon: CircleIcon,
    shortcut: '6',
  },
  {
    id: 'text',
    name: 'Text',
    icon: TextIcon,
    shortcut: '7',
  },
  {
    id: 'eraser',
    name: 'Eraser',
    icon: EraserIcon,
    shortcut: '8',
  },
];
